<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 10">
    <path d="M.71,10a1.32,1.32,0,0,0,.68-.23l6.94-4C8.83,5.5,9,5.31,9,5s-.17-.51-.67-.79L1.39.22A1.4,1.4,0,0,0,.71,0C.27,0,0,.33,0,.84V9.15C0,9.66.27,10,.71,10Z"/>
</svg>